module.exports = __webpack_public_path__ + "static/3-kada-a317ab90a49c6684325ba6a513f68d53.svg";